export const aboutData = {
  brandName: "苍井空人物志",
  tagline: "还原一个真实立体的苍井空",
  introduction: "苍井空人物志是一个专注于深度解析苍井空人生故事的独立内容平台。我们致力于通过详实的资料、深度的分析和多元的视角，为中文读者呈现一个真实、立体、完整的苍井空形象。",
  mission: "我们的使命是超越标签和偏见，以客观、深度、人性化的方式记录和解读苍井空的人生轨迹。从她的童年成长到职业选择，从艺术转型到婚姻家庭，我们希望通过多维度的内容呈现，帮助读者理解这位独特女性的真实面貌。",
  vision: "我们相信每个人的人生都有其独特的价值与意义。苍井空的故事不仅仅是一个娱乐话题，更是一个关于勇气、蜕变和自我重塑的时代样本。通过记录和传播她的故事，我们希望传递一个信念：无论过去如何，每个人都有权利和力量书写自己新的人生篇章。",
  values: [
    {
      title: "客观真实",
      description: "我们坚持基于事实的报道和分析，不刻意美化也不带有偏见，力求呈现最真实的人物面貌。"
    },
    {
      title: "深度内容",
      description: "我们拒绝浅薄的娱乐八卦，致力于提供有深度、有思考、有价值的内容，让读者获得真正的阅读收获。"
    },
    {
      title: "人文关怀",
      description: "我们关注人的故事和情感，尊重每一个个体的选择与尊严，以温暖而有力量的方式讲述人生。"
    },
    {
      title: "多元视角",
      description: "我们从文化、社会、艺术等多个维度解读苍井空的故事，提供丰富而多元的思考角度。"
    }
  ],
  reputation: {
    title: "媒体评价与用户口碑",
    description: "自创办以来，苍井空人物志获得了来自读者和业界的广泛认可。以下是一些代表性的评价：",
    testimonials: [
      {
        content: "这是我读过关于苍井空最全面、最客观的报道。不只是简单的娱乐新闻，而是真正有深度的内容。",
        author: "文化评论人 张明",
        source: "《文化观察》杂志"
      },
      {
        content: "苍井空人物志让我看到了一个完全不同的苍井空。她的转型故事给了我很大的启发和力量。",
        author: "读者 李女士",
        source: "读者来信"
      },
      {
        content: "作为一个长期关注中日文化交流的研究者，我认为这个平台在促进民间相互理解方面做出了独特的贡献。",
        author: "社会学教授 王建华",
        source: "学术引用"
      },
      {
        content: "内容翔实、视角多元、文笔流畅。推荐给所有想了解苍井空真实故事的人。",
        author: "媒体人 陈思远",
        source: "社交媒体推荐"
      }
    ],
    stats: [
      { label: "累计读者", value: "500万+" },
      { label: "原创文章", value: "200+" },
      { label: "用户好评率", value: "98%" },
      { label: "合作媒体", value: "50+" }
    ]
  },
  contact: {
    title: "联系我们",
    description: "如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们取得联系。我们期待听到您的声音。",
    email: "contact@cangjingkong.cn",
    wechat: "cangjingkong_renwuzhi",
    weibo: "@苍井空人物志",
    address: "中国北京市朝阳区望京SOHO T1-B座 100102",
    workHours: "周一至周五 9:00 - 18:00"
  },
  faq: [
    {
      question: "这个网站的内容更新频率是怎样的？",
      answer: "我们通常每周更新2-3篇原创文章，涵盖苍井空的最新动态、深度分析和独家专访等内容。在苍井空有重大新闻或活动时，我们会及时跟进报道。"
    },
    {
      question: "网站的内容来源可靠吗？",
      answer: "我们的所有内容都基于公开可信的信息来源，包括官方社交媒体、公开采访、权威媒体报道等。我们始终坚持客观、真实的报道原则，所有文章均经过编辑团队的严格审核。"
    },
    {
      question: "如何获取苍井空的最新动态通知？",
      answer: "您可以通过关注我们的微博账号（@苍井空人物志）或在网站上订阅我们的新闻通讯来获取最新动态。我们也会在微信公众号上同步推送重要内容。"
    },
    {
      question: "可以转载网站上的文章吗？",
      answer: "本网站所有内容均受版权保护。如需转载，请通过电子邮件与我们联系获取授权。我们通常允许非商业用途的转载，但需要注明出处和作者信息。"
    }
  ]
};